<template lang="pug">
  .crud(v-shortcuts="[{ shortcut: [ 'c', ], callback: addContact, push: true, focus: true },{ shortcut: [ 'e', ], callback: editShortcut, push: true, focus: true },{ shortcut: [ 'f', ], callback: setFocusSearch, push: true, focus: true },]")
    modal-import(model="contact" :title="$t('front.import_modal', {model: $t('strings.contact')})")
    modal-contacts(:newRecord='newRecord', :is-add='isModalAdd')
    .container-fluid
      vm-row.heading(vm-w="12")
        vm-col(vm-type="flex" vm-align="center" vm-lg=6 vm-sm=6)
          div
            h2 {{ $t('strings.contacts') }}:
            span {{ $t('strings.description', {attribute: $t('strings.contacts')}) }}
          div(style="display:none;")
            vm-button(type="default" icon="list")
            vm-button(type="default" icon="grid" color="rgba(var(--gray),1)")
        vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-lg=6 vm-sm=6)
          div
            //- vm-button(icon="plus" @click="addContact") {{ $t('strings.add') }}
            vm-tooltip(:text="$t('strings.options')" delay=".5s")
              vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click)
                vm-button(type="border" icon="more-horizotnal" color="#afbbc6")

                vm-dropdown-menu
                  vm-dropdown-item.d-flex.justify-content-between(@click="printReport")
                    vm-icon(icon="printer-outline")
                    slot &nbsp;{{ $t('strings.print') }}
                  vm-dropdown-item.d-flex.justify-content-between(@click="deleteContactsConfirm" :disabled="!enabledDelete")
                    vm-icon(icon="trash-2-outline")
                    slot &nbsp;{{ $t('strings.delete') }}
                  vm-dropdown-item.d-flex.justify-content-between(@click="setModalImportVisible(true)")
                    vm-icon(icon="upload-outline")
                    slot &nbsp;{{ $t('strings.import') }}
                  //- More options
                      Agrega mas acciones para colecciones de datos
      vm-row(vm-w="12")
        vm-col.card(vm-sm=12)
          vm-table(multiple v-model="selected"  max-height="350px" :data="contacts")
            template(slot="header")
              .d-flex.justify-content-between
                vm-input(ref="search" icon="search" size="small" :placeholder="searchPlaceholder" v-model="filters.where.param" @keyup.enter="applyFilter(filters)"  width="300px")
                div
                  vm-order-by(:sort-by-text="$t('strings.order_by')" placeholder="Ninguno" :data="columnsOrderBy" v-model="filters.orderBy" @change="applyFilter(filters)" size="small" width="200px" :serializer="item => $t('contacts.'+ item)")
                  vm-tooltip(:text="$t('strings.filters')" delay=".5s")
                    vm-dropdown(ref='dropdown' vm-custom-content vm-trigger-click vm-trigger-outside-click)
                      vm-button(type="default" icon="funnel-outline" size="small")

                      vm-dropdown-menu(class="filters")
                        .heading.d-flex.justify-content-between
                          h4 {{ $t('strings.filters') }}
                          vm-button(type="flat" size="small" @click="clearFilter") {{ $t('strings.clear') }}
                        //- Add filters
                            Agrega los filtros que prefieras por ejemplo:
                            vm-select.filter(:placeholder="$t('strings.multiple')" multiple autocomplete label="Status" v-model="filters.whereIn.status")
                              vm-select-item(:key="index" :value="item.value" :text="item.text" v-for="(item,index) in status")
                            vm-select.filter(url="customers" columns="tradename,etc" :placeholder="$t('strings.multiple')" multiple autocomplete :label="$t('sales.customer_id')" v-model="filters.whereIn.customer_id" @input-change="autoCompleteFunc")
                              vm-select-item(:key="index" :value="item.id" :text="item.tradename" v-for="(item,index) in contactsCatalog.customers")
                            vm-date-picker.filter(type="daterange" :label="$t('contacts.created_at')" :placeholder="$t('strings.select_date')" @on-change="handleChange" :value="filters.betweenDates.created_at")

                            NOTA: (agregar clase .filter)
                        .filter.d-flex
                          vm-button(@click="applyFilter(filters)") {{ $t('strings.apply') }}
                  vm-tooltip(:text="$t('strings.display_list')" delay=".5s")
                    vm-button(type="default" size="small" icon="list")
                  vm-tooltip(:text="$t('strings.display_grid')" delay=".5s")
                    vm-button(type="default" size="small" icon="grid" color="rgba(var(--gray),1)")
            template(slot="thead")
              vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columns") {{ $t('contacts.' + column) }}
            template(slot-scope="{data}")
              vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
                vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columns")
                  slot(v-if="column != 'status' && column != 'message'") {{ data[indextr][column] }}
                  slot(v-if="column == 'message'") {{ data[indextr][column] }}
                  vm-status-indicator(v-if="column == 'status'" :pulse="data[indextr]['status'] !== 'Activo'" :color="colorStatus(data[indextr]['status'])") {{ status[data[indextr]['status']].text }}
                vm-td
                vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click)
                  vm-button(type="flat" icon="more-horizotnal" color="#afbbc6")

                  vm-dropdown-menu
                    vm-dropdown-item.d-flex.justify-content-between(@click="editContact(data[indextr], tr)")
                      vm-icon(icon="edit-2-outline")
                      slot &nbsp;{{ $t('strings.change_status') }}
                    vm-dropdown-item.d-flex.justify-content-between(@click="deleteContactConfirm(data[indextr])")
                      vm-icon(icon="trash-2-outline")
                      slot &nbsp;{{ $t('strings.delete') }}
                    vm-dropdown-item.d-flex.justify-content-between(v-if="data[indextr]['status'] == '3'" @click="editContact(data[indextr])")
                      vm-icon(icon="eye-outline")
                      slot &nbsp;{{ $t('strings.view') }}
                    //- More actions
          vm-pagination(:total="pagination.totalPages" v-model="currentPage" goto)
          transition(name="enter")
            .total-records(v-if="total>0") Total: {{ total | currency }}
</template>

<script>
import ModalContacts from '@/components/modals/ModalContacts.vue'
import ModalImport from '@/components/modals/ModalImport.vue'
import parseDeleteMany from '@/utils/parseDeleteMany'
import parseVuexObject from '@/utils/parseVuexObject'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Contacts')

export default {
  name: 'Contacts',
  components: {
    ModalContacts,
    ModalImport
  },
  data: () => ({
    currentPage: 1,
    isModalAdd: true,
    newRecord: {},
    selected: [],
    columns: [
      'name',
      'email',
      'phone',
      'message',
      'status'
    ],
    columnsOrderBy: [
      // Nota solo si las columnas son atributos
    ],
    status: [
      {
        text: 'Nuevo',
        value: 0,
        color: 'success'
      },
      {
        text: 'Espera',
        value: 1,
        color: 'warning'
      },
      {
        text: 'Atendido',
        value: 2,
        color: 'danger'
      }
    ],
    filters: {
      // Nota: Estos campos se parsearan en el v-model de los filtros. Ver linea 60
      where: {
        name: '',
        email: '',
        param: ''
      },
      whereIn: {
        // Agrega las columnas que se filtraran con mas de una opcion ejemplo: status: []
      },
      whereBetween: {
        // Agrega las columnas que se filtraran entre paramentros ejemplo: priece: []
      },
      betweenDates: {
        // Agrega las columnas que se filtraran entre fechas: created_at: []
      },
      orderBy: ''
    },
    filtersClear: {}
  }),
  async created () {
    this.filtersClear = parseVuexObject(this.filters)
    await this.getContacts(1)
    // await this.getContactsCatalog()
  },
  methods: {
    ...mapActions([
      'deleteContact',
      'deleteContacts',
      'loadContacts',
      'loadCatalog',
      'getContactsCatalog',
      'actionContact',
      'setModalImportVisible',
      'setModalVisible',
      'printReport',
      'applyFilter',
      'clearFilter'
    ]),
    colorStatus (code) {
      return this.status.find(e => e.value === parseInt(code))['color']
    },
    setFocusSearch () {
      this.$refs.search.$refs.vminput.focus()
    },
    editShortcut () {
      if (this.selected.length === 0 || this.selected.length > 1) return
      const idx = this.contacts.findIndex(u => u.id === this.selected[0].id)
      this.editContact(this.selected[0], idx)
    },
    addContact () {
      this.isModalAdd = true
      this.setModalVisible(true)
      this.newRecord = {}
    },
    editContact (contact, index) {
      this.isModalAdd = false
      this.setModalVisible(true)
      this.newRecord = { ...contact }
    },
    async deleteContactConfirm (contact) {
      let t = this
      this.auxDeleteContact = () => {
        t.deleteContact(contact).then(() => { t.selected = [] })
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation', { model: this.$t('strings.contact'), attribute: this.$t(contact.name) }),
        accept: this.auxDeleteContact
      })
    },
    async deleteContactsConfirm () {
      let t = this
      let contactsMany = parseDeleteMany(this.selected, 'name')
      this.auxDeleteContact = () => {
        t.deleteContacts(contactsMany).then(() => { t.selected = [] })
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation', { model: this.$t('strings.contact'), attribute: contactsMany.values }),
        accept: this.auxDeleteContact
      })
    },
    async setActionContact (record, action) {
      record.id && this.actionContact({ id: record.id, action })
    },
    async getContacts (page) {
      let t = this
      this.loadContacts({ page }).then(data => t.getProps(t.$route.params.id))
    },
    getProps (index) {
      let contact = this.contacts.filter(contact => contact.id === parseInt(index))[0]
      contact && this.editContact(contact, index)
    },
    autoCompleteFunc (value, url) {
      this.loadCatalog({ filter: value, url: url })
    },
    newObjectFuncModal (value) {
      //
    },
    newObjectFuncView (value) {
      //
    },
    handleChange (date) {
      // this.filters.betweenDates.created_at = date
    },
    hiddeDrop () {
      let [dropdownMenu] = this.$refs.dropdown.$children.filter((item) => {
        return item.hasOwnProperty('dropdownVisible')
      })
      dropdownMenu.dropdownVisible = false
    }
  },
  computed: {
    ...mapGetters([
      'contacts',
      'pagination',
      'filterParams'
    ]),
    searchPlaceholder () {
      let t = this
      let concatColumns = Object.keys(this.filters.where).reduce((str, column, index) => {
        if (column !== 'param' && index < Object.keys(t.filters.where).length - 2) return (index > 0) ? `${str}, $\{t.$t('contacts.' + column)}` : `${str} ${t.$t('contacts.' + column)}`
        return str
      }, '')
      return this.$t('strings.search', { attribute: this.$t('strings.contact'), columns: concatColumns, column: this.$t('contacts.' + Object.keys(this.filters.where)[Object.keys(t.filters.where).length - 2]) })
    },
    enabledDelete () {
      return this.selected.length > 0
    },
    total () {
      return this.selected.reduce((prev, cur) => prev + parseFloat(cur.total), 0).toFixed(2)
    }
  },
  watch: {
    currentPage (currentPage) {
      this.getContacts(currentPage)
    },
    filterParams (filter) {
      this.hiddeDrop()
      filter.length === 0 && (this.filters = parseVuexObject(this.filtersClear))
      this.selected = []
      this.currentPage = 1
      this.getContacts(this.currentPage)
    }
  }
}
</script>

<style lang="scss">
.filters {
  .filter {
    padding: 5px 10px;
    width: 250px;
  }
}
.con-vm-tooltip {
  display: inline-block;
  position: relative;
}
.vm-table--header {
  padding: 10px;
  span:nth-child(1)  {
    width: 100%;
  }
  .input-select-con{
    span {
      width: auto !important;
    }
  }
  .justify-content-between {
    div:last-child {
      .vm-button {
        margin: 0 3px;
      }
      .vm-con-dropdown {
        float: left;
      }
      .con-select {
        display: inline-block;
        input {
          height: 32px;
        }
      }
    }
  }
}
</style>
